(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["parallax-image-gallery"] && !Shopify.designMode) return;
  try {
    
// 等待页面加载完成
document.addEventListener('DOMContentLoaded', function() {
  // 确保GSAP和ScrollTrigger已加载
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.error('GSAP或ScrollTrigger未加载');
    return;
  }
  
  // 注册ScrollTrigger插件
  gsap.registerPlugin(ScrollTrigger);
  
  // 获取section元素
  const section = document.querySelector('.parallax-section');
  
  if (!section) return;
  
  // 初始化视差效果
  function initParallax() {
    // 获取所有图片行
    const rows = document.querySelectorAll('.parallax-row');
    
    if (rows.length === 0) return;
    
    // 计算section的高度（移除单位，只获取数值）
    const sectionHeight = parseFloat(section.style.height) || 
                         parseFloat(getComputedStyle(section).height) || 
                         500;
    
    // 清理之前的ScrollTrigger
    ScrollTrigger.getAll().forEach(trigger => {
      if (trigger.trigger === section) {
        trigger.kill();
      }
    });
    
    // 为每行创建动画
    rows.forEach((row, index) => {
      // 计算移动方向：第1行向左，第2行向右，第3行向左
      const direction = index % 2 === 0 ? -1 : 1;
      
      // 获取行内所有图片
      const images = row.querySelectorAll('.parallax-image');
      if (images.length === 0) return;
      
      const imageWidth = images[0].offsetWidth;
      const gap = parseInt(getComputedStyle(row).gap) || 8;
      const imagesPerRow = images.length;
      const totalRowWidth = (imageWidth + gap) * imagesPerRow;
      const viewportWidth = window.innerWidth;
      
      // 计算需要移动的距离（大约是行宽的一半）
      const moveDistance = totalRowWidth / 2;
      
      // 重置行位置
      gsap.set(row, { x: 0 });
      
      // 为每行创建独立的ScrollTrigger
      const animation = gsap.fromTo(row, 
        { x: direction === -1 ? moveDistance * 0.2 : -moveDistance * 0.2 },
        { 
          x: direction * moveDistance,
          ease: "none"
        }
      );
      
      // 创建ScrollTrigger
      ScrollTrigger.create({
        animation: animation,
        trigger: section,
        start: "top 80%", // 当section顶部到达视口80%时开始
        end: "bottom 20%", // 当section底部到达视口20%时结束
        scrub: 2, // 稍微平滑的滚动
        markers: false, // 开发时可设为true查看触发点
        invalidateOnRefresh: true, // 刷新时重新计算
        onEnter: () => {
          section.classList.add('active');
        },
        onLeave: () => {
          section.classList.remove('active');
        },
        onEnterBack: () => {
          section.classList.add('active');
        },
        onLeaveBack: () => {
          section.classList.remove('active');
        }
      });
    });
    
    // 刷新ScrollTrigger以确保正确计算
    ScrollTrigger.refresh();
  }
  
  // 等待所有图片加载完成
  const images = section.querySelectorAll('img');
  let loadedImages = 0;
  
  function checkAllImagesLoaded() {
    loadedImages++;
    if (loadedImages === images.length) {
      setTimeout(initParallax, 100);
    }
  }
  
  if (images.length === 0) {
    setTimeout(initParallax, 100);
    return;
  }
  
  images.forEach(img => {
    if (img.complete) {
      checkAllImagesLoaded();
    } else {
      img.addEventListener('load', checkAllImagesLoaded);
      img.addEventListener('error', checkAllImagesLoaded);
    }
  });
  
  // 如果所有图片已经加载完成
  if (loadedImages === images.length) {
    setTimeout(initParallax, 100);
  }
  
  // 窗口大小变化时重新初始化
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      initParallax();
    }, 250);
  });
});

  } catch(e) { console.error(e); }
})();
})();
